import BaseAPI from "../api";

const path: string = "/publish_online_course";

export class PublishOnlineCourseApi extends BaseAPI {
    static list(query: any): Promise<any> {
        return this.api.get(`${path}`, { params: { ...query } });
    }
    static my_active(query: any): Promise<any> {
        return this.api.get(`/my_active_online_course`, { params: { ...query } });
    }
    static my_bookmark(query: any): Promise<any> {
        return this.api.get(`/my_bookmark_online_course`, { params: { ...query } });
    }
    static my_completed(query: any): Promise<any> {
        return this.api.get(`/my_completed_online_course`, { params: { ...query } });
    }
    static my_online_course_diploma(query: any): Promise<any> {
        return this.api.get(`/my_online_course_diploma`, { params: { ...query } });
    }
    static id(id: any): Promise<any> {
        return this.api.get(`${path}/${id}`)
    }
    static getReview(id: any): Promise<any> {
        return this.api.get(`${path}/${id}/review`)
    }
    static cancel(id: any): Promise<any> {
        return this.api.get(`my_online_course/${id}/cancel`)
    }
    static my_online_course_diploma_by_id(id: any): Promise<any> {
        return this.api.get(`my_online_course_diploma/${id}`, { responseType: "arraybuffer", })
    }
    static patchReview(id: any, body: any): Promise<any> {
        return this.api.patch(`${path}/${id}/review`, body)
    }
    static form_answer(id: any): Promise<any> {
        return this.api.get(`my_online_course/${id}/form_answer`)
    }
    static grading(id: any): Promise<any> {
        return this.api.get(`my_online_course/${id}/grading`)
    }
    static post_form_answer(id: any, body: any): Promise<any> {
        return this.api.post(`my_online_course/${id}/form_answer`, body,)
    }
    static update_step(id: any, body: any): Promise<any> {
        return this.api.patch(`my_online_course/${id}/update_step`, body,)
    }
    static purchase(body: any, id: any): Promise<any> {
        return this.api.post(`/publish_online_course/${id}/purchase`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static purchaseAll(body: any): Promise<any> {
        return this.api.post(`publish_online_courses_purchase`,
            body,
            {
                headers: { "Content-Type": "multipart/form-data" },
            }
        );
    }
    static bookmark(is_booked: any, id: any): Promise<any> {
        console.log(is_booked);
        return this.api.patch(`${path}/${id}/bookmark?is_booked=${is_booked}`,
            // { params: { ...query } }
        );
    }
}
